import { useEffect } from "react";
import { Box } from "@mui/material";
import { useBreadcrumb } from "../../contexts/BreadcrumbContext.jsx";
import ClaimsListTable from "../../components/tables/ClaimsListTable.jsx";

/**
 * Schaden List Page
 * Full-width overview of all damage claims (layout follows the Klick-Dummy).
 */
export default function ClaimIndexPage() {
  const { setBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Schäden", path: "/schaeden" },
    ]);
  }, [setBreadcrumbs]);

  return (
    <Box>
      <ClaimsListTable />
    </Box>
  );
}
